import I18n from 'i18n-js';
import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import SellingSpot from '../../models/selling/SellingSpot';
import { Coordinate } from '../../models/tariff/trafficAreas/Coordinate';
import { ApplicationState } from '../../store';
import { getSellingSpotsActions } from '../../store/selling/actions';
import ContentLayout from '../core/ContentLayout';
import MapSpots from '../shared/maps/MapSpots';
import PrometTable from '../shared/promet-table/PrometTable';
import PinDropIcon from '@material-ui/icons/PinDrop';

type Props = typeof mapDispatchToProps;

const SellingSpots = (props: Props) => {

    const [mapActiveMarker, setActiveMarker] = React.useState<Coordinate | undefined>(undefined);

    const sellingSpots = useSelector((state: ApplicationState) => state.selling.sellingSpots);

    useEffect(() => {
        getSellingSpots();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const getSellingSpots = () => {
        props.getSellingSpots();
    }

    const onShowOnMapClick = (sellingSpot: SellingSpot) => {
        setActiveMarker({ ...sellingSpot.coordinate });
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const onActiveMarkerChange = (coordinate?: Coordinate) => {
        setActiveMarker(coordinate);
    }

    return (
        <ContentLayout titleTranslateId='sellingSpots.title'>
            {
                sellingSpots && sellingSpots.length > 0 &&
                <>
                    <MapSpots sellingSpots={sellingSpots} activeMarker={mapActiveMarker} onActiveMarkerChange={onActiveMarkerChange} />
                    <PrometTable
                        data={sellingSpots}
                        columns={
                            [
                                {
                                    accessor: (s: SellingSpot) => s.name,
                                    align: 'left', className: "font-weight-500"
                                },
                                {
                                    accessor: (s: SellingSpot) => s.fullAddress
                                },
                                {
                                    cell: (s: SellingSpot) => [...new Set(s.workingHours)].map((workingHours, i) => <div key={i}>{workingHours}</div>),
                                    align: 'left'
                                },
                                {
                                    cell: (s: SellingSpot) => (
                                        <>
                                            <span onClick={() => onShowOnMapClick(s)} className="selling-spot-pin">
                                                <PinDropIcon className="icon-pin" />
                                            </span>
                                            <Button type="button" color="primary" onClick={() => onShowOnMapClick(s)} className="selling-spot-button text-nowrap">
                                                {I18n.t('sellingSpots.showOnMapButton')}
                                            </Button>
                                        </>
                                    )
                                },
                            ]
                        }
                        hideHeader
                        hideFooter
                    />
                </>
            }
            {
                sellingSpots?.length === 0 &&
                <div className='d-flex justify-content-center mb-5 pb-5 mt-5 pt-5'>
                    <span>{I18n.t('noResults')}</span>
                </div>
            }
        </ContentLayout>
    );
}

const mapDispatchToProps = {
    getSellingSpots: getSellingSpotsActions.request
};

export default connect(null, mapDispatchToProps)(SellingSpots as any);
